import {Modal} from "react-bootstrap";
import React, {Component} from 'react';
import {withMediaQuery} from '../../../utilities/hooks/useMediaQuery';

class EmailEditorPreview extends Component {

    render() {
        const {isMobile} = this.props;

        return (
            <Modal
                animation={false}
                show={this.props.show}
                onHide={this.props.onHide}
                className={"heightAuto maxHeight90 modalLeadsFilterBody fontIOS"}
                style={this.props.overflow}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={isMobile ? "preview_modal preview_modal_scroll" : "preview_modal"}>
                    {this.props.children}
                </Modal.Body>
            </Modal>
        )
    }
}

const EmailEditorPreviewWithMedia = withMediaQuery(EmailEditorPreview, {
    isMobile: { maxWidth: 991 },
});

export default EmailEditorPreviewWithMedia;
